module.exports = __webpack_public_path__ + "img/avatar0.61c55093.png";